import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { PainScoreCatActionV2 } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-pain-score-cat-slot-v2',
    templateUrl: './pain-score-cat-slot-v2.component.html',
    styleUrl: './pain-score-cat-slot-v2.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PainScoreCatSlotComponentV2 implements SheetSlotComponentBase {

	action!: PainScoreCatActionV2;
	value!: string | null;

	@Input('action') set updateAction(action: PainScoreCatActionV2 | null) {
		this.action = action as PainScoreCatActionV2;
		this.value = this.action.totalScore?.toString() ?? null;
	}

	constructor() {
	}
}
